import React, { useState } from 'react';
import useConstant from 'use-constant';
import { useAsync } from 'react-async';
import awesomeDebouncePromise from 'awesome-debounce-promise';
import useAutosuggest from '@stencil/use-autosuggest';
import megatron from '@stencil/megatron';

const Autosuggest = props => {
  const ListElement = props => <div>{props.children}</div>;
  const InputElement = props => <input {...props} />;
  const itemElementDefault = item => <div>{item.n}</div>;
  const onItemSelectionDefault = change => {};
  const itemToStringDefault = item => item.n;
  const massageDataDefault = items => items;
  const selectTextOnFocus = props.selectTextOnFocus;

  const {
    initialInputValue = '',
    placeholder = '',
    onItemSelection = onItemSelectionDefault,
    itemToString = itemToStringDefault,
    itemElement = itemElementDefault,
    getUrl,
    Input = InputElement,
    List = ListElement,
    massageData = massageDataDefault,
    isCityCountry = false
  } = props;
  const DEBOUNCE_TIMEOUT = 150;

  // const toggleOverlay = flag => {
  //   setDisplayOverlay(flag);
  // };

  const locationSearchURL = (search_query: string) => {
    return getUrl(search_query);
  };

  const fetchVoyagerLocationSuggestions = async ({ inputValue }, { signal }) => {
    const fetchVoyagerUrlForInput = locationSearchURL(inputValue);

    if (!inputValue || inputValue === initialInputValue) {
      return [];
    }

    var headers = new Headers();
    headers.append('x-pfm', window.flavour || '');
    headers.append('currency', 'inr');
    headers.append('locale', 'en-IN');

    const res = await megatron({
      name: 'flights_autosuggest_voyager_api',
      type: 'GET',
      headers,
      url: fetchVoyagerUrlForInput,
      credentials: 'omit',
      trackLatency: { timeout: 2000, data: { serviceApp: 'aerial', apiTimeout: true } },
      moreOptions: { signal }
    });

    if (res && res.r) {
      if (isCityCountry && inputValue.length < 4) {
        res.r.splice(0, 0, { con: 'ANYWHERE', iata: '', n: 'Anywhere' });
      }
      return res.r;
    }
  };

  const debouncedVoyagerFetchPromise = useConstant(() =>
    awesomeDebouncePromise(fetchVoyagerLocationSuggestions, DEBOUNCE_TIMEOUT)
  );

  const inputRef = React.useRef(null);

  React.useEffect(() => {
    if (inputRef.current && isOpen) {
      const distanceBtwInputAndWindowBottom =
        window.innerHeight -
        (inputRef.current.getBoundingClientRect().y + inputRef.current.offsetHeight);

      const proportionalDistance = distanceBtwInputAndWindowBottom / window.innerHeight;
      const percentageDistance = proportionalDistance * 100;
      const factorOfReductionForMenuHeight = percentageDistance * 0.625;

      const menuHeight = factorOfReductionForMenuHeight;

      setMenuHeight(menuHeight);
    }
  }, [isOpen]);

  const {
    propGetters: { getInputProps, getMenuProps, getItemProps, getRootProps, getLabelProps },
    state: { isOpen, highlightedIndex, selectedItem, inputValue }
  } = useAutosuggest({
    itemToString,
    initialInputValue,
    onSelectedItemChange(changes) {
      onItemSelection(changes.selectedItem, 'autoSuggest');
      // toggleOverlay(false);
    }
  });

  const {
    data: items = [],
    isPending,
    isRejected,
    error
  } = useAsync({
    promiseFn: debouncedVoyagerFetchPromise,
    watch: inputValue,
    inputValue
  });

  const itemsArr = massageData(items);

  return (
    <div>
      <Input
        name="autosuggest"
        type="text"
        data-cy="inputAutoSuggest"
        {...getInputProps({
          ref: inputRef,
          placeholder,
          onFocus: e => {
            if (selectTextOnFocus) {
              e.target.select();
            }
            // toggleOverlay(true);
          },
          onBlur: () => {
            // toggleOverlay(false);
          }
        })}
      />
      <List>
        <div {...getMenuProps()}>
          {(isOpen &&
            itemsArr &&
            itemsArr.map((item, index) => {
              return (
                <div
                  key={item._id}
                  {...getItemProps({
                    item,
                    index
                  })}
                >
                  {itemElement(item)}
                </div>
              );
            })) ||
            null}
        </div>
      </List>
    </div>
  );
};

export default Autosuggest;
